import Enumerable from "linq";
import store from "../../../../../store";
import { IFormatValidatable } from "../IFormatValidatable";
import { FormatStructureEditor, IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IConfiguration } from "../../configuration";

export abstract class AbstractFormatValidator implements IFormatValidatable {
  protected get configuration(): IConfiguration {
    return store.getters.configuration;
  }

  protected processObjects<T>(source: FormatStructureEditor, process: (o: IFormatObjectEditable, pi: number) => T): T[] {
    return Enumerable.from(source.getPages())
      .selectMany((p, i) => p.getObjects().map(o => process(o, i)))
      .toArray();
  }

  protected extractObjects(source: FormatStructureEditor): IFormatObjectEditable[] {
    return this.processObjects(source, o => o);
  }

  protected concat<T>(...source: (T[] | T | null | undefined)[]): T[] {
    return Enumerable.from(source)
      .selectMany(s => !!s ? (Array.isArray(s) ? s : [ s ]) : [])
      .toArray();
  }

  public abstract validate(format: FormatStructureEditor): IFormatAlert[];
}
